import { render, staticRenderFns } from "./CompanyCredit.vue?vue&type=template&id=13c289b5"
import script from "./CompanyCredit.vue?vue&type=script&lang=js"
export * from "./CompanyCredit.vue?vue&type=script&lang=js"
import style0 from "./CompanyCredit.vue?vue&type=style&index=0&id=13c289b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports